import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  label: {
    fontSize: '1rem',
    color: theme.evPalette.charcoal[800],
    marginBottom: theme.spacing(1),
    '&.Mui-error': {
      color: `${theme.evPalette.rose[900]} !important`,
    },
    '& .myev-MuiFormLabel-asterisk.Mui-error': {
      color: `${theme.evPalette.rose[900]} !important`,
    },
  },
  asterisk: {
    color: theme.evPalette.rose[900],
  },
  paymentInfoContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
  },
  fieldContainer: {
    gap: '8px',
    '& .myev-MuiFormHelperText-contained': {
      marginLeft: 0,
    },
    '& .myev-MuiCheckbox-root': {
      marginLeft: '-9px',
    },
  },
  ccConsentContainer: {
    '& .myev-MuiFormHelperText-contained': {
      marginLeft: 0,
    },
    '& .myev-MuiCheckbox-root': {
      marginLeft: '-9px',
    },
    '& p': {
      color: '#000000',
    },
    '& .myev-MuiInputLabel-formControl': {
      position: 'inherit',
      top: 'inherit',
      left: 'inherit',
      transform: 'inherit',
    },
    '& .myev-MuiCheckbox-root:has(input:focus)': {
      animation: '$checkboxPop',
      animationDuration: '1s',
    },
  },
  '@keyframes checkboxPop': {
    '0%': {
      backgroundColor: '#acacb4',
    },
    '50%': {
      backgroundColor: '#ced2d3',
    },
    '70%': {
      backgroundColor: '#e1e3e4',
    },
    '100%': {
      backgroundColor: 'transparent',
    },
  },
  cardInputText:
  {
    maxWidth: '782px',
    '& > .Mui-error > fieldset': {
      borderColor: `${theme.evPalette.rose[900]} !important`,
    },
    // #genai Prevent browser autofill from turning the input blue
    '& input:-webkit-autofill, & input:-webkit-autofill:hover, & input:-webkit-autofill:focus': {
      '-webkit-box-shadow': '0 0 0 30px #ffffff inset !important',
      '-webkit-text-fill-color': '#1B202C !important',
    },
  },
  cardNumberInputText: {
    maxHeight: '40px',
    maxWidth: '782px',
    '& > .Mui-error > fieldset': {
      borderColor: `${theme.evPalette.rose[900]} !important`,
    },
    '& iframe': {
      height: '40px !important',
      minHeight: '40px !important',
      maxHeight: '40px !important',
      // #genai Explicit white background prevents browser autofill blue on CyberSource iframes
      backgroundColor: '#ffffff',
      border: '1px solid rgba(0, 0, 0, 0.23) !important',
      borderRadius: '4px',
      padding: '8px',
      '& input': {
        fontSize: '16px',
      },
      '&:hover': {
        border: '1px solid #000 !important',
      },
    },
  },
  // #genai Phase 2 error state for CyberSource hosted-field iframes (routing/account/confirm/card
  // number). Only the border turns red (#BC1616) — no fill — so it matches the Billing Information
  // fields, which highlight just the border on error. Applied via an explicit class because the
  // cross-origin iframe has no MUI .Mui-error hook.
  hostedFieldError: {
    '& iframe': {
      border: '1px solid #BC1616 !important',
    },
  },
  cardInputTextFullWidth:
  {
    width: '100%',
    '& > .Mui-error > fieldset': {
      borderColor: `${theme.evPalette.rose[900]} !important`,
    },
    // #genai Prevent browser autofill from turning the input blue
    '& input:-webkit-autofill, & input:-webkit-autofill:hover, & input:-webkit-autofill:focus': {
      '-webkit-box-shadow': '0 0 0 30px #ffffff inset !important',
      '-webkit-text-fill-color': '#1B202C !important',
    },
  },
  cardInputHelperText: {
    color: `${theme.evPalette.rose[900]} !important`,
  },
  cardContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '1rem',
    flexWrap: 'nowrap',
    flexGrow: 1,
  },
  cardContainerSplit: {
    display: 'flex',
    gap: '1rem',
    flexWrap: 'nowrap',
    flexGrow: 1,
    '@media (max-width: 640px)': {
      flexDirection: 'column',
    },
  },
  cardTypeContainer: {
    width: theme.spacing(26),
    '& >.Mui-error > fieldset': {
      borderColor: `${theme.evPalette.rose[900]} !important`,
    },
    '& > p.Mui-error': {
      color: `${theme.evPalette.rose[900]} !important`,
    },
    '@media (max-width: 640px)': {
      width: 'auto',
      flexGrow: 1,
      flexBasis: 0,
    },
  },
  cardTypeOptions: {
    borderRadius: 4,
    fontSize: 16,
    '& .myev-MuiOutlinedInput-input': {
      padding: '10.5px 14px',
    },
  },
  panelHeader: {
    display: 'flex',
  },
  secondaryHeader: {
    fontWeight: 400,
    color: theme.evPalette.charcoal[800],
    fontSize: '14px',
    '@media (min-width: 640px)': {
      marginLeft: theme.spacing(1),
    },
  },
  cardNumberContainer: {
    flexGrow: 1,
    maxWidth: '558px',
    '@media (max-width: 640px)': {
      width: 'auto',
      flexGrow: 1,
      flexBasis: 0,
    },
  },
  cardNumberContainerFullWidth: {
    flexGrow: 1,
    '@media (max-width: 500px)': {
      width: 'auto',
      flexGrow: 1,
      flexBasis: 0,
    },
  },
  expirationContainer: {
    '& label': {
      fontWeight: '400',
    },
    gap: '1rem',
    '@media (max-width: 640px)': {
      flexBasis: 0,
      flexGrow: 1,
    },
  },
  monthContainer: {
    width: theme.spacing(26),
    '& >.Mui-error > fieldset': {
      borderColor: `${theme.evPalette.rose[900]} !important`,
    },
    '& > p.Mui-error': {
      color: `${theme.evPalette.rose[900]} !important`,
    },
    '@media (max-width: 640px)': {
      width: 'auto',
      flexGrow: 1,
      flexBasis: 0,
    },
  },
  yearContainer: {
    width: theme.spacing(26),
    '& >.Mui-error > fieldset': {
      borderColor: `${theme.evPalette.rose[900]} !important`,
    },
    '& > p.Mui-error': {
      color: `${theme.evPalette.rose[900]} !important`,
    },
    '@media (max-width: 640px)': {
      width: 'auto',
      flexGrow: 1,
      flexBasis: 0,
    },
  },
  accountBalance: {
    fontWeight: 600,
  },
  planType: {
    paddingBottom: theme.spacing(2),
  },
  paymentOption: {
    fontWeight: 600,
    fontSize: theme.spacing(1.5),
  },
  cardChargeMessage: {
    fontFamily: 'Noto Sans',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '18px',
    textAlign: 'left',
    color: '#4D5365 !important',
  },
  ccErrorHelperText: {
    color: `${theme.evPalette.rose[900]} !important`,
    fontFamily: 'Noto Sans',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '18px',
    textAlign: 'left',
    height: '18px',
  },
  checkboxContainer: {
    display: 'flex',
    '& .myev-MuiCheckbox-colorPrimary.Mui-checked': {
      color: theme.evPalette.ocean[600],
    },
  },
  // #genai Phase 2 consent error: the Terms checkbox outline turns rose alongside the red helper text.
  // The render site applies this class conditionally rather than selecting off the FormControl — MUI v4
  // keeps `error` in context only and never stamps `Mui-error` on the FormControl's own node, so a
  // descendant selector would never match. Phase 1 keeps the default grey checkbox.
  phase2CcConsentError: {
    '& .myev-MuiCheckbox-root': {
      color: theme.evPalette.rose[900],
    },
  },
  // #genai Phase 2 only: semibold 16px field label per Figma 226:26066 (Noto Sans SemiBold,
  // #4D5365, asterisk #BC1616). Additive — Phase 1 keeps using `label`.
  // #genai Phase 2 field-error UX (Figma 269:21936): labels keep their default color on error —
  // only the input box and helper text turn red. No `.Mui-error` overrides here; the render
  // sites deliberately drop the label's `error` prop so it never picks up MUI's error class.
  phase2Label: {
    fontFamily: 'Noto Sans',
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '24px',
    color: '#4D5365',
    marginBottom: '8px',
  },
  // #genai Phase 2 only: two fields side-by-side (First/Last name, Account/Confirm number).
  // Additive — not referenced by the Phase 1 layout. Collapses to a column on mobile.
  phase2Row: {
    display: 'flex',
    flexDirection: 'row',
    gap: '16px',
    width: '100%',
    maxWidth: '776px',
    '@media (max-width: 639px)': {
      flexDirection: 'column',
    },
  },
}));
